import React from 'react';

const RATIO_MAP = [
  { label: "21:9", w: 27, h: 12 },
  { label: "16:9", w: 24, h: 14 },
  { label: "3:2",  w: 21, h: 14 },
  { label: "4:3",  w: 20, h: 15 },
  { label: "5:4",  w: 18, h: 15 },
  { label: "1:1",  w: 16, h: 16 },
  { label: "4:5",  w: 16, h: 18 },
  { label: "3:4",  w: 15, h: 20 },
  { label: "2:3",  w: 14, h: 21 },
  { label: "9:16", w: 12, h: 24 },
];

const getRatioDimensions = (label) => {
  const found = RATIO_MAP.find(r => r.label === label);
  if (found) return found;
  
  if (label && label.includes(':')) {
    const [wStr, hStr] = label.split(':');
    const w = Number(wStr);
    const h = Number(hStr);
    if (!isNaN(w) && !isNaN(h)) {
      const max = Math.max(w, h);
      if (max > 0) {
        return { label, w: Math.round((w/max)*24), h: Math.round((h/max)*24) };
      }
    }
  }
  return { label, w: 16, h: 16 };
};

export default function AspectRatioSelector({ options = [], value, onChange }) {
  const displayRatios = options.map(opt => getRatioDimensions(opt));

  return (
    <div style={{
      background: "var(--s2)",
      borderRadius: 12,
      padding: 12,
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(54px, 1fr))",
      gap: 6,
    }}>
      {displayRatios.map((r) => {
        const isActive = value === r.label;
        return (
          <button
            key={r.label}
            onClick={(e) => {
              e.preventDefault();
              onChange?.(r.label);
            }}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 5,
              padding: "8px 4px",
              borderRadius: 8,
              border: "none",
              background: isActive ? "var(--acg)" : "transparent",
              cursor: "pointer",
              color: isActive ? "var(--ac3)" : "var(--t3)",
              fontSize: 10,
              fontFamily: "inherit",
              transition: "background 0.15s, color 0.15s",
            }}
            onMouseEnter={e => {
              if (!isActive) {
                e.currentTarget.style.background = "var(--s3)";
                e.currentTarget.style.color = "var(--t1)";
              }
            }}
            onMouseLeave={e => {
              if (!isActive) {
                e.currentTarget.style.background = "transparent";
                e.currentTarget.style.color = "var(--t3)";
              }
            }}
          >
            <div style={{
              width: r.w,
              height: r.h,
              border: `2px solid ${isActive ? "var(--ac3)" : "var(--t3)"}`,
              borderRadius: 3,
              transition: "border-color 0.15s",
            }} />
            <span>{r.label}</span>
          </button>
        );
      })}
    </div>
  );
}
